export default "/images/eac94ae997815dd54d04330559afe310.avif";